export const isTronLinkBrowser = (ua: string) => /TronLink/i.test(ua);

export const hasInjectedTronLinkWallet = (win: Window) => {
  const tronWindow = win as Window & {
    tron?: { isTronLink?: boolean };
    tronLink?: unknown;
    tronWeb?: { defaultAddress?: { base58?: string } };
  };

  return Boolean(
    tronWindow.tron?.isTronLink ||
    tronWindow.tronLink ||
    tronWindow.tronWeb?.defaultAddress?.base58,
  );
};